
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical-disclaimer",
      function () {
        return require("private-next-pages/medical-disclaimer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical-disclaimer"])
      });
    }
  